import axiosInstance from '@/api/axiosInstance';
import type {
  TeamOverviewResponse,
  TeamCourseProgressResponse,
  AvailablePath,
  AssignPathPayload,
  AssignPathResponse,
} from './types';

/**
 * Fetch team overview for the logged-in manager
 * GET /api/manager/team-overview
 * Requires ROLE_MANAGER, ROLE_OWNER_GM, or ROLE_SUPER_ADMIN
 */
export const fetchTeamOverview = async (): Promise<TeamOverviewResponse> => {
  const response = await axiosInstance.get<{ data: TeamOverviewResponse }>(
    '/api/manager/team-overview'
  );
  return response.data.data;
};

/**
 * Fetch course-progress for the logged-in manager's team
 * GET /api/manager/courses/team-progress
 * Requires ROLE_MANAGER, ROLE_OWNER_GM, or ROLE_SUPER_ADMIN
 */
export const fetchTeamCourseProgress =
  async (): Promise<TeamCourseProgressResponse> => {
    const response = await axiosInstance.get<{
      data: TeamCourseProgressResponse;
    }>('/api/manager/courses/team-progress');
    return response.data.data;
  };

/**
 * Fetch available learning paths for assignment
 * GET /api/manager/team/available-paths
 */
export const fetchAvailablePaths = async (): Promise<AvailablePath[]> => {
  const response = await axiosInstance.get<{ data: AvailablePath[] }>(
    '/api/manager/team/available-paths'
  );
  return response.data.data;
};

/**
 * Assign a learning path to team members
 * POST /api/manager/team/assign-path
 */
export const assignPathToTeam = async (
  payload: AssignPathPayload
): Promise<AssignPathResponse> => {
  const response = await axiosInstance.post<{ data: AssignPathResponse }>(
    '/api/manager/team/assign-path',
    payload
  );
  return response.data.data;
};
